export default __webpack_public_path__ + "static/media/cmw-og-image.59227acd.webp";